import { TrackEvent } from "@api/apiClient";
import { TrackEventCore } from "@utils/trackEvents";

export enum EventStatus { WAIT, ACTIVE, DONE, ERROR }

export interface ParcelModalTimelineProps {
  items: TrackEventCore[];
  countryCode: string;
  tracking: string;
  estimatedLastMileArrivalTime?: string;
}

// export type ExtendedTrackEvent = Partial<TrackEventCore> & {
export type ExtendedTrackEvent = Partial<TrackEvent> & {
  id: string;
  status: EventStatus;
  name: string;
  statuses: TrackEventCore[];
}
